import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const ConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/connections" */
    'routes/Control/Connections/ConnectionsRoute'
  )
));

const getControlConnectionsRoutes = () => {
  return [
    {path: paths.getPathControlConnections(), component: ConnectionsRoute},
  ]
}



export { getControlConnectionsRoutes };
